/**
 * Dealer Directory analytics event constants (Dealer Directory M12).
 */

export const DEALER_DIRECTORY_SOURCE_PAGE = "dealer_directory";

export const DEALER_DIRECTORY_ANALYTICS_SOURCE_COMPONENTS = {
  PAGE: "dealer_directory_page",
  GRID: "dealer_directory_grid",
  MAP: "dealer_directory_map",
  CARD: "dealer_directory_card",
  FEATURED: "dealer_directory_featured",
  FILTERS: "dealer_directory_filters",
  SORT: "dealer_directory_sort",
  HERO: "dealer_directory_hero",
  TRUST_BLOCK: "dealer_directory_trust_block",
  EMPTY_STATE: "dealer_directory_empty_state",
  ERROR_STATE: "dealer_directory_error_state",
  MOBILE_FILTERS: "dealer_directory_mobile_filters",
  HOMEPAGE: "dealer_directory_homepage",
  SEARCH_RESULTS: "dealer_directory_search_results",
  VEHICLE_DETAIL: "dealer_directory_vehicle_detail",
  DEALER_PROFILE: "dealer_directory_dealer_profile",
  FOOTER: "dealer_directory_footer",
};

export const DEALER_DIRECTORY_ANALYTICS_EVENTS = {
  VIEWED: "dealer_directory_viewed",
  EMPTY_VIEWED: "dealer_directory_empty_viewed",
  ERROR_VIEWED: "dealer_directory_error_viewed",

  CARD_CLICKED: "dealer_directory_card_clicked",
  PROFILE_CLICKED: "dealer_directory_profile_clicked",
  INVENTORY_CLICKED: "dealer_directory_inventory_clicked",
  SEARCH_CTA_CLICKED: "dealer_directory_search_cta_clicked",
  CHECKLIST_CLICKED: "dealer_directory_checklist_clicked",
  NAV_CLICKED: "dealer_directory_nav_clicked",

  FILTER_CHANGED: "dealer_directory_filter_changed",
  FILTER_REMOVED: "dealer_directory_filter_removed",
  FILTERS_CLEARED: "dealer_directory_filters_cleared",
  SORT_CHANGED: "dealer_directory_sort_changed",
  FILTER_DRAWER_OPENED: "dealer_directory_filter_drawer_opened",
  FILTER_DRAWER_CLOSED: "dealer_directory_filter_drawer_closed",

  FEATURED_SECTION_VIEWED: "dealer_directory_featured_section_viewed",
  FEATURED_DEALER_CLICKED: "featured_dealer_clicked",
  FEATURED_DEALER_PROFILE_CLICKED: "featured_dealer_profile_clicked",

  FOOTER_CLICKED: "dealer_directory_footer_clicked",
  HOMEPAGE_CLICKED: "dealer_directory_homepage_clicked",
  SEARCH_RESULTS_CLICKED: "dealer_directory_search_results_clicked",
  VEHICLE_DETAIL_CLICKED: "dealer_directory_vehicle_detail_clicked",
  DEALER_PROFILE_CLICKED: "dealer_directory_dealer_profile_clicked",
};

export const DEALER_DIRECTORY_ERROR_CATEGORIES = {
  NETWORK_ERROR: "network_error",
  SERVICE_UNAVAILABLE: "service_unavailable",
  PARSE_ERROR: "parse_error",
  UNKNOWN: "unknown",
};

export const DEALER_DIRECTORY_EMPTY_TYPES = {
  GLOBAL: "global",
  FILTERED: "filtered",
};

/** Mobile filter drawer analytics ship in M13. */
export const DEALER_DIRECTORY_MOBILE_FILTER_BREAKPOINT_PX = 640;
